import { Component, OnInit, AfterViewInit } from "@angular/core";
import { ReportService } from "../report.service";
//Import Custom Services Here
import { SchoolService } from "../../../shared/services/school.service";
import { StaffTypeService } from "../report-services/staff-type.service";
import { InstructorService } from "../report-services/instructor.service";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { DialogService } from "primeng/dynamicdialog";
import { MergeToGroupDialogComponent } from "../merge-to-group-dialog/merge-to-group-dialog.component";
import { MergeToGroupRequest } from "../report-services/merge-to-group-request";
import * as moment from "moment";

@Component({
	templateUrl: "./staffinoutscan.component.html",
})
export class StaffInOutScanComponent implements OnInit {
	constructor(
		private selectService: SchoolselectorService,
		private reportService: ReportService,
		//Insert Custom Services Here
		private stafftypeService: StaffTypeService,
		private instructorService: InstructorService,
		private schoolService: SchoolService,
		private dialogService: DialogService
	) {}
	report = {
		//Insert Custom Parameters Here
		SchoolID: 0,
		StaffPersonID: 0,
		StaffTypeID: 0,
		StartDate: new Date(),
		EndDate: new Date(),
		ImageLogo: "",
		ActiveID: -1,
	};

	//Insert Custom Lists Here
	schoolList: any = [];
	StaffPersonList: any = [];
	StaffTypeList: any = [];
	ImageLogoList: any = [];

	OutputTypeID: any = 1;
	OutputTypeList = [
		{
			ID: 1,
			Desc: ".PDF",
		},
		// {
		//     ID: 2,
		//     Desc: ".Doc (Word Document)" //Doesn't seem to work
		// },
		// {
		//     ID: 3,
		//     Desc: ".xls (Excel file)" //Ending Support for xls, just use CSV
		// },
		{
			ID: 4,
			Desc: ".CSV (Excel file)",
		},
		{
			ID: 5,
			Desc: ".RTF (Rich Text File)",
		},
		// {
		//     ID: 6,
		//     Desc: ".XML" //Doesn't seem to work
		// },
		{
			ID: 7,
			Desc: ".HTM (Web Page)",
		},
		// {
		//     ID: 8,
		//     Desc: ".rpt" //Doesn't seem to work
		// },
		// {
		//     ID: 9,
		//     Desc: ".grp" //Doesn't seem to work
		// }
	];

	lstActive: any = [
		{
			ID: -1,
			Desc: "All",
		},
		{
			ID: 1,
			Desc: "Active",
		},
		{
			ID: 0,
			Desc: "Inactive",
		},
	];

	ReportID: number = 344;

	subscription: any;

	user: any;
	errorMessage: any = "";
	isProcessing: any = false;
	ngOnInit() {
		//Insert Custom Init Methods Here
		// this.loadSchoolist()
		// this.loadStaffPersonList()
		// this.loadStaffTypeList()

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school.SchoolID);
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	onSchoolChange(value) {
		this.report.SchoolID = value;
		this.loadStaffTypeList();
		this.loadLogolist();
	}

	onStaffTypeChange(value) {
		this.report.StaffTypeID = value;

		this.loadStaffPersonList();
	}

	onActiveChange(value) {
		this.report.ActiveID = value;

		this.loadStaffPersonList();
	}

	private loadSchoolist() {
		var result = this.schoolService.GetSchoolsForUserReport(344);
		result.subscribe(
			(response) => {
				this.schoolList = response;

				if (this.schoolList.length > 1) {
					this.schoolList.unshift({
						SchoolID: 0,
						SchoolName: "All Schools",
					});
				} else {
					this.onSchoolChange(this.schoolList[0].SchoolID);
				}
			},
			(error) => {}
		);
	}

	private loadStaffTypeList() {
		this.report.StaffTypeID = 0;
		var result = this.stafftypeService.loadSTAFFTYPEList(0, this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.StaffTypeList = response;

				this.report.StaffTypeID = this.StaffTypeList[0].PersonTypeID;

				this.loadStaffPersonList();
			},
			(error) => {}
		);
	}

	private loadStaffPersonList() {
		this.StaffPersonList = [];

		this.report.StaffPersonID = 0;
		var result = this.instructorService.loadPersonByStaffType(this.report.SchoolID, this.report.StaffTypeID, this.report.ActiveID);
		result.subscribe(
			(response) => {
				this.StaffPersonList = response;

				this.StaffPersonList.unshift({
					Teacher_PersonID: 0,
					Instructor: "All Staff",
					Active: true,
				});

				this.report.StaffPersonID = this.StaffPersonList[0].Teacher_PersonID;
			},
			(error) => {}
		);
	}

	private loadLogolist() {
		var result = this.reportService.ImageLogoGetList("", this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.ImageLogoList = response;

				this.report.ImageLogo = this.ImageLogoList[0].ImageLibraryID;
			},
			(error) => {}
		);
	}

	Print() {
		var component = this;
		this.errorMessage = "";

		//Insert Custom Error Checks Here
		if (!this.report.SchoolID) {
			this.errorMessage = "Select the School";
			return;
		}

		// if (!this.report.StaffPersonID) {
		// 	this.errorMessage = "Select the StaffPerson"
		// 	return;
		// }

		// if (!this.report.StaffTypeID) {
		// 	this.errorMessage = "Select the StaffType"
		// 	return;
		// }

		// if (!this.report.StartDate) {
		// 	this.errorMessage = "Select the StartDate"
		// 	return;
		// }

		// if (!this.report.EndDate) {
		// 	this.errorMessage = "Select the EndDate"
		// 	return;
		// }

		var strParam = this.GetStrParam();
		this.isProcessing = true;

		var reportID = 344;

		var result = this.reportService.Print(reportID, strParam, this.report.SchoolID, this.OutputTypeID);

		result.subscribe(
			(response: any) => {
				component.isProcessing = false;
				window.open(response);
			},
			(error) => {
				component.errorMessage = error;
				component.isProcessing = false;
			}
		);
	}

	GetStrParam(): string {
		var strParam: string = "";

		//Parameter 1: SchoolID
		strParam += this.report.SchoolID + "|SchoolID";

		//Parameter 2: StaffPersonID
		strParam += "," + this.report.StaffPersonID + "|StaffPersonID";

		//Parameter 3: StaffTypeID
		strParam += "," + this.report.StaffTypeID + "|StaffTypeID";

		//Parameter 4: StartDate
		strParam += "," + moment(this.report.StartDate).format("MM/DD/YYYY") + "|StartDate";

		//Parameter 5: EndDate
		strParam += "," + moment(this.report.EndDate).format("MM/DD/YYYY") + "|EndDate";

		//Parameter 6: Active
		strParam += "," + this.report.ActiveID + "|Active";

		//Parameter 7: ImageLogo
		strParam += "," + this.report.ImageLogo + "|Imagelogo";

		return strParam;
	}

	MergeToGroup() {
		this.errorMessage = "";

		this.isProcessing = true;
		var strParam = this.GetStrParam();

		var parms: MergeToGroupRequest = {
			ReportID: this.ReportID,
			SchoolID: this.report.SchoolID,
			strParms: strParam,
		};

		var result = this.reportService.MergeToGroupSelectInfo(parms);
		result.subscribe(
			(response: any) => {
				if (response.length > 0) {
					var ref = this.dialogService.open(MergeToGroupDialogComponent, {
						header: "Merge to Group",
						width: "fit-content",
						data: {
							//INSERT Custom Data here
							lstPerson: response,
							SchoolID: this.report.SchoolID,
						},
					});
					ref.onClose.subscribe((response) => {
						if (response == 1) {
						}
					});
				} else {
					this.errorMessage = "No Data available";
				}

				this.isProcessing = false;
			},
			(error) => {
				this.errorMessage = error;
				this.isProcessing = false;
			}
		);
	}
}
